<template>
  <div class="max-h-screen overflow-y-auto xl:pb-1 pb-10">
    <!-- Summary Header -->
    <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-700 p-4 rounded-lg mb-4">
      <div class="grid grid-cols-4 gap-4 text-center">
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-blue-600">{{ List.length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Atanan Araç</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-green-600">{{ List.filter(v => v.isCustom === 1).length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Manuel Atama</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-purple-600">{{ List.filter(v => v.isCustom !== 1).length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Otomatik Öneri</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-orange-600">{{ List.reduce((sum, v) => sum + (v.allCost || 0), 0).toFixed(0) }}₺</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Toplam Maliyet</div>
        </div>
      </div>
      
      <!-- Bulk Actions -->
      <div v-if="selectedItems.length > 0" class="mt-4 flex items-center justify-between bg-red-50 dark:bg-red-900/20 p-3 rounded-lg border border-red-200 dark:border-red-800">
        <div class="flex items-center">
          <i class="fas fa-check-circle text-red-500 mr-2"></i>
          <span class="text-sm font-medium text-red-700 dark:text-red-300">{{ selectedItems.length }} araç seçildi</span>
        </div>
        <div class="flex space-x-2">
          <button
            type="button"
            @click="clearSelection"
            class="px-3 py-1 text-xs bg-gray-500 hover:bg-gray-600 text-white rounded-md transition-colors duration-200"
          >
            Seçimi Temizle
          </button>
          <button
            type="button"
            @click="bulkDelete"
            class="px-3 py-1 text-xs bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors duration-200"
          >
            <i class="fas fa-trash mr-1"></i>Seçilenleri Sil
          </button>
        </div>
      </div>
    </div>
    
    <div
      class="shadow overflow-x-scroll border border-gray-200 bg-white dark:bg-gray-900 rounded-xl mb-4 h-80"
    >
      <vehicleModal :detail="selected" />
      <vehicle-conflict-modal @close="reset" :visible="isVehicleConflictModalVisible.show" :orderInfo="isVehicleConflictModalVisible.order" :vehicleInfo="isVehicleConflictModalVisible.vehicle" />
      <table class="min-w-full divide-y divide-gray-200">
        <thead
          class="bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800"
        >
          <tr>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 70px !important"
            >
              <input
                type="checkbox"
                :checked="allSelected"
                @change="toggleAllSelection"
                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              >
              <span class="ml-2">#</span>
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 280px !important"
            >
              <i class="fas fa-file-invoice mr-1"></i>Sipariş
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 280px !important"
            >
              <i class="fas fa-truck mr-1"></i>Araç
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 180px !important"
            >
              <i class="fas fa-map-marker-alt mr-1"></i>Konum
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 180px !important"
            >
              <i class="fas fa-tint mr-1"></i>Yıkama Noktası
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-hand-holding-usd mr-1"></i>Yıkama
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-road mr-1"></i>Sefer
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-calculator mr-1"></i>Toplam
            </th>
            <th
              v-if="!hiddenInsert"
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider"
              style="min-width: 90px !important"
            >
              <i class="fas fa-cogs mr-1"></i>İşlemler
            </th>
          </tr>
        </thead>
        <tbody
          v-if="!isMultipleDay"
          class="divide-y-2 divide-gray-500"
          style="background-color: #3a3a3a"
        >
          <newVehicle
            v-if="changeState == false && !hiddenInsert"
            @addItem="(r) => addItem(r)"
            :order="orders"
            :products="products"
            :customers="customers"
            :vehicleList="vehicleList"
            :selectedVehicles="List"
            :hiddenInsert="hiddenInsert"
            @isVehicleConflictModalVisible="(event)=>isVehicleConflictModalVisible=event"
          />

          <tr
            v-show="
              (!changeState || List?.length > 0) &&
              !load &&
              !isRecommendationInProgress
            "
            v-for="(item, index) in List"
            :key="index"
            @click="toggleRowSelection(item, index, $event)"
            :class="{
              'bg-gray-700 dark:bg-blue-900/20 border-l-4': isSelected(item, index),
              'border-l-blue-500': isSelected(item, index) && item.isCustom !== 1,
              'border-l-green-500': isSelected(item, index) && item.isCustom === 1
            }"
            class="cursor-pointer transition-all duration-200 select-none"
          >
            <td class="table-td border-r border-opacity-20">
              <div class="flex items-center">
                <input
                  type="checkbox"
                  :value="item.id || index"
                  v-model="selectedItems"
                  @click.stop
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mr-2"
                >
                <span># {{ index + 1 }}</span>
              </div>
            </td>

            <td class="table-td border-r border-opacity-20">
              <span>
                {{
                  orders?.find((orderItem) => orderItem.orderNo == item.orderNo)
                    .name
                }}
              </span>
            </td>

            <td
              class="table-td border-r border-opacity-20 flex justify-between items-center"
            >
              <div class="w-1/2 flex items-center">
                <p class="w-1/2">
                  {{ item.vehicle }}
                </p>
                <p class="w-1/2">{{ item.capacity / 1000 }} TON</p>
              </div>
              <div class="w-1/2 flex justify-between items-center">
                <img
                  :title="item.romorkType"
                  v-if="item.capacity / 1000 <= 52 && item.capacity / 1000 > 20"
                  class="w-12 h-8"
                  src="@/assets/vehicles/fuel-truck.png"
                  alt=""
                />
                <img
                  :title="item.romorkType"
                  v-if="item.capacity / 1000 <= 20"
                  class="w-10 h-8"
                  src="@/assets/vehicles/tank-truck.png"
                  alt=""
                />
                <span
                  class="px-2 bg-red-600 rounded-xl text-white text-xs inline-block font-extralight"
                  v-if="item.isCustom == 1"
                >
                  Manuel Atama
                </span>
              </div>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p>
                {{ item.address + " / " + Money(item?.recomendation.isWashing == 1 && item?.washPointName != null ? item?.distanceWithWashing : item.distance) + " KM" }}
              </p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p>
                {{ item.washPointName }}
              </p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.washCost >= 0">
                {{ item.washCost }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.recomendationTotalCost >= 0">
                {{ item.recomendationTotalCost }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.allCost >= 0">
                {{ Number(item.allCost).toFixed(2) }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td v-if="!hiddenInsert" class="flex justify-center items-center">
              <button
                type="button"
                class="process-btn mr-2"
                @click.stop="vehicleDetailItem(item)"
              >
                <i class="fas fa-search"></i>
              </button>
              <button
                type="button"
                class="process-btn"
                @click.stop="deleteItem(item, index)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          <td
            :colspan="hiddenInsert ? 8 : 9"
            class="text-center p-4 text-white"
            v-if="
              changeState == true &&
              List?.length == 0 &&
              !load &&
              !isRecommendationInProgress
            "
          >
            <i class="fas fa-recycle fa-3x"></i>
            <h3 class="text-2xl mt-2">ARAÇ PLANLA</h3>
            <p class="text-sm my-2 text-white text-opacity-75">
              bu sipariş için araç planlamak için planla butonuna basınız
            </p>
            <button
              class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 shadow-lg"
              type="button"
              @click="() => calculateVehicle()"
            >
              <i class="fas fa-magic mr-2"></i>Araç Öner
            </button>
          </td>
        </tbody>
        <tableLoader
          :load="load || isRecommendationInProgress"
          length="1"
          :colspan="hiddenInsert ? 8 : 9"
        />
      </table>
    </div>
  </div>
</template>

<script>
// NPM
import _ from "lodash";
import similarity from "similarity";

// Global Components
import vehicleModal from "@/components/modals/vehicle.detail.modal/index.vue";
import tableLoader from "@/components/general/table-loader.vue";
// import reloadVehicleList from "@/components/general/reload-vehicle-list.vue";

// Local Components
import newVehicle from "./new.vehicle.vue";

// Utils
import {
  getCustomers,
  getLocationAll,
  getProducts,
  customer,
} from "@/utils/detailData";
import {
  recommendMultipleVehiclesForOrder,
  calculateDistancePriority,
  calculateCustomerPriority,
  isVehicleSuitableForOrderDetail,
  isWashStatus,
  haversineDistance,
} from "@/utils/recomendation";
import { checkCargoCompatibility } from "@/utils/recomendation/controller/checkCargoCompatibility";
import moment from "moment";

//Axios
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
import VehicleConflictModal from '../../../../../../../components/modals/VehicleConflictModal.vue';

export default {
  name: "vehicle-table",
  props: ["orders", "shipId", "isLaterAddOrder", "totalCount", "haveType", "recomendedCount"],
  components: {
    tableLoader,
    newVehicle,
    vehicleModal,
    VehicleConflictModal,
  },
  data() {
    return {
      isVehicleConflictModalVisible:{show:false,order:{},vehicle:{}},
      activeEror: "",
      load: false,
      changeState: true,
      List: [],
      // isRecomendedListEmpty: false,
      dedicatedVehicles: [],
      currentVehicles: [],
      vehicleList: [],
      customers: [],
      products: [],
      new: {
        vehicle: "",
        dorse: "",
        driverName: "",
        driverTC: "",
      },
      washingLocations: [],
      insufficientErr: false,
      vehicleArrivalTime: "",
      recAccVehicleCapacity: 0,
      currAccVehicleCapacity: 0,
      isDeleted: false,
      selected: { id: "", plaque: "", vehicleId: "" },
      hiddenInsert: false,
      isManuel: false,
      newOrder: undefined,

      isCalculationInProgress: false,
      isRecommendationInProgress: false,
      debouncedCalculateVehicle: _.debounce(this.calculateVehicle, 300),
      
      // Bulk selection
      selectedItems: [],
    };
  },

  methods: {
    reset(){
      this.isVehicleConflictModalVisible={show:false,order:{},vehicle:{}};
    },
    // Bulk selection methods
    toggleAllSelection() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.List.map((item, index) => item.id || index);
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    bulkDelete() {
      if (this.selectedItems.length === 0) return;

      this.$swal.fire({
        icon: 'warning',
        title: 'Toplu Silme',
        text: `${this.selectedItems.length} araç silinecek. Emin misiniz?`,
        showCancelButton: true,
        confirmButtonText: 'Evet, Sil',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#dc2626'
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedIds = new Set(this.selectedItems);
          
          // Filter out selected items
          this.List = this.List.filter((item, index) => {
            const itemId = item.id || index;
            return !selectedIds.has(itemId);
          });
          
          // Clear selection
          this.selectedItems = [];
          
          // Emit change
          this.$emit("change", this.List);
          
          this.$swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: 'Seçilen araçlar silindi.',
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    },
    // Row selection methods
    toggleRowSelection(item, index, event) {
      // Prevent event propagation to avoid triggering form submissions
      event.preventDefault();
      event.stopPropagation();
      
      // Prevent triggering on interactive elements
      if (event.target.tagName === 'BUTTON' || 
          event.target.tagName === 'INPUT' || 
          event.target.closest('button') ||
          event.target.closest('input')) {
        return;
      }
      
      const itemId = item.id || index;
      const currentIndex = this.selectedItems.indexOf(itemId);
      
      if (currentIndex > -1) {
        this.selectedItems.splice(currentIndex, 1);
      } else {
        this.selectedItems.push(itemId);
      }
    },
    isSelected(item, index) {
      const itemId = item.id || index;
      return this.selectedItems.includes(itemId);
    },
    addItem(item) {
      if (item) {
        const order = this.orders?.find(
          (orderItem) => orderItem.orderNo == item.orderNo
        );
        const findProduct = this.products.find((pValue) => {
          return (
            similarity(
              pValue?.name?.toString().toLocaleLowerCase().replace(/\s/g, ""),
              order?.productType
                ?.toString()
                .toLocaleLowerCase()
                .replace(/\s/g, "")
            ) >= 0.8
          );
        });
        if (findProduct?.typeId === 2) {
          //  Araçta bu dorse türü olup olmadığını kontrol et
          const findDorseType = findProduct.dorseTypes.filter((find) => {
            if (
              typeof find.name == "string" &&
              typeof item.romorkType == "string"
            ) {
              if (
                similarity(
                  find?.name.toLowerCase().replace(/\s/g, ""),
                  item?.romorkType?.toLowerCase().replace(/\s/g, "")
                ) > 0.85
              ) {
                return find;
              }
            }
          });

          const allADRDorse = item?.romorkType?.includes("ADR");
          const ADRVehicle = item?.transportPurpose?.includes("TEHLİKELİ");

          if (!allADRDorse || !ADRVehicle || findDorseType.length < 1) {
            this.$swal
              .fire({
                icon: "warning",
                title: this.$t("general.warningTitle"),
                text: "Uygun olmayan araç",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: this.$t("general.confirmText"),
                cancelButtonText: this.$t("general.rejectText"),
                customClass: {
                  popup: "w-1/2",
                },
                html: `<div class="flex flex-col items-center">
                ${
                  findDorseType.length < 1
                    ? `<span class="w-full">
                      Bu araç bu ürünü taşımak için uygun bir dorseye sahip
                      değildir!
                    </span>`
                    : ""
                }
                ${
                  !allADRDorse
                    ? `<span class="w-full">
                      Bu aracın dorsesi tehlikeli ürün taşımaya uygun değildir!
                    </span>`
                    : ""
                }
                ${
                  !ADRVehicle
                    ? `<span class="w-full">
                      Bu çekici tehlikeli ürün taşımaya uygun değildir!
                    </span>`
                    : ""
                }
                <br/>
                <span class="w-full">Devam etmek istediğinize emin misiniz?</span>
                </div>`,
              })
              .then((acc) => {
                if (acc.isConfirmed) {
                  this.addVehicle(item);
                }
              });
          } else {
            this.addVehicle(item);
          }
        } else {
          this.addVehicle(item);
        }
      }
    },
    addVehicle(item) {
      this.insufficientErr = false;
      let index = this.List.some((r) => parseInt(r.id) == parseInt(item.id));
      if (!index) {
        this.isDeleted = true;
        this.isManuel = true;

        const vehicleIndex = this.vehicleList.findIndex(
          (vitem) => vitem.id == item.id
        );

        const order = this.orders?.find(
          (orderItem) => orderItem.orderNo == item.orderNo
        );

        // Müşteri bazlı kargo uyumluluğunu kontrol et
        const vehicleLastProduct = item.lastProduct || item.productId;
        const cargoCompatibility = checkCargoCompatibility(
          vehicleLastProduct,
          this.customers,
          order.customer
        );

        this.vehicleList[vehicleIndex].orderNos = [item.orderNo];
        this.List.push({
          ...item,
          plate: item.name,
          vehicle: item.name,
          latitude: Number(item.latitude),
          longitude: Number(item.longitude),
          isRent: item?.haveType ?? item?.isRent,
          distance: calculateDistancePriority(
            {
              startLat: order.outpointLat,
              startLng: order.outpointLng,
              outpointLat: order.outpointLat,
              outpointLng: order.outpointLng
            },
            { latitude: item.latitude, longitude: item.longitude }
          ),
          isCustom: 1,
          recomendation: {
            isWashing: isWashStatus(this.customers, this.products, item, order)
              .status,
            isIncompatible: !cargoCompatibility.isCompatible,
            incompatibilityReason: cargoCompatibility.reason,
            rejectedProduct: cargoCompatibility.rejectedProduct,
          },
        });

        this.$emit("addVehicle", true);

        setTimeout(() => {
          this.isDeleted = false;
          this.isManuel = false;
        }, 50);
      } else {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "Bu Araç Zaten Listede Var",
          false,
          this.$t("general.OkayTitle")
        );
      }
    },
    deleteItem(detail, index) {
      this.$swal.fire({
        icon: 'warning',
        title: 'Araç Çıkarma',
        text: 'Aracı listeden çıkarmak istediğinize emin misiniz?',
        showCancelButton: true,
        confirmButtonText: 'Evet, Çıkar',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#dc2626'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isDeleted = true;
          const vehicleIndex = this.vehicleList.findIndex(
            (item) => item.id == detail.id
          );

          if (vehicleIndex > -1) {
            this.vehicleList[vehicleIndex].orderNos = [];
          }

          this.List.splice(index, 1);
          this.$emit("removeVehicle", true);

          setTimeout(() => {
            this.isDeleted = false;
          }, 50);
        }
      });
    },
    vehicleDetailItem(item) {
      const { latitude, longitude, ...rest } = item;
      const order = this.orders?.find(
        (orderItem) => orderItem.orderNo == item.orderNo
      );

      // Müşteri bazlı kargo uyumluluğunu kontrol et
      const vehicleLastProduct = item.lastProduct || item.productId;
      const cargoCompatibility = checkCargoCompatibility(
        vehicleLastProduct,
        this.customers,
        order.customer
      );

      if (item.isCustom == 2) {
        this.selected = {
          outpointLng: Number(order.outpointLng),
          outpointLat: Number(order.outpointLat),
          targetPointLat: Number(order.targetPointLat),
          targetPointLng: Number(order.targetPointLng),
          ...rest,
          tonnage: item.recomendation.capacity,
          orderAmount: Number(order.amount),
          recomendation: {
            ...item.recomendation,
            position: { lat: latitude, lng: longitude },
            isIncompatible: !cargoCompatibility.isCompatible,
            incompatibilityReason: cargoCompatibility.reason,
            rejectedProduct: cargoCompatibility.rejectedProduct,
          },
        };
      } else {
        this.selected = {
          outpointLng: Number(
            order.outpointLng ? order.outpointLng : order.fillingLongitude
          ),
          outpointLat: Number(
            order.outpointLat ? order.outpointLat : order.fillingLatitude
          ),
          targetPointLat: Number(
            order.targetPointLat ? order.targetPointLat : order.deliveryLatitude
          ),
          targetPointLng: Number(
            order.targetPointLng
              ? order.targetPointLng
              : order.deliveryLongitude
          ),
          ...rest,
          tonnage: item.capacity,
          orderAmount: Number(order.amount),
          recomendation: {
            ...item.recomendation,
            name: item.vehicle,
            position: { lat: latitude, lng: longitude },
            capacity: item.capacity,
            customerPriority: calculateCustomerPriority(order, this.customers),
            distancePriority: calculateDistancePriority(
              {
                startLat: Number(
                  order.outpointLat ? order.outpointLat : order.fillingLatitude
                ),
                startLng: Number(
                  order.outpointLng ? order.outpointLng : order.fillingLongitude
                ),
              },
              { latitude: latitude, longitude: longitude }
            ).toFixed(2),
            ...isVehicleSuitableForOrderDetail(
              order,
              item,
              this.products,
              false,
              false
            ),
            isIncompatible: !cargoCompatibility.isCompatible,
            incompatibilityReason: cargoCompatibility.reason,
            rejectedProduct: cargoCompatibility.rejectedProduct,
          },
        };
      }
      this.$modal.show("vehicle-modal");
    },
    async vehicleRecomended(item, blockedVehicles = []) {
      if (this.isRecommendationInProgress) {
        console.log(
          "vehicleRecomended: A recommendation is already in progress"
        );
        return null;
      }

      this.isRecommendationInProgress = true;

      try {
        const order = {
          ...item,
          orderNo: item.orderNo,
          //haveType: this.haveType === 3 ? null : this.haveType,
          startLat: item.outpointLat ? item.outpointLat : item.fillingLatitude,
          startLng: item.outpointLng ? item.outpointLng : item.fillingLongitude,
          endLat: item.targetPointLat
            ? item.targetPointLat
            : item.deliveryLatitude,
          endLng: item.targetPointLng
            ? item.targetPointLng
            : item.deliveryLongitude,
          deliveryDate: item.deliveryDate
            ? item.deliveryDate
            : item.estimatedComplateDate,
          tonnage:
            item.unitType === "TON"
              ? parseFloat(item.amount || item.tonnage)
              : item.tonnage * 26,
          productName: item.productType,
          productId: item.productId,
          token: this.$store.state.userData.token,
        };
        this.newOrder = order;
        
        if (!("productId" in order) || order.productId === undefined) {
          order.productId = this.products.find((product) => product.name.trim() === order.productType.trim())?.id;
        }

        // Sadece aktif araçları blockedVehicles olarak gönder
        // Durdurulup salınan araçlar (isStopped = 1 veya isReleasedFromShip = 1) hariç tutulur
        const activeCurrentVehicles = this.currentVehicles.filter(vehicle => {
          return !(vehicle.isStopped === 1 || vehicle.isReleasedFromShip === 1);
        });

        const activeListVehicles = this.List.filter(vehicle => {
          return !(vehicle.isStopped === 1 || vehicle.isReleasedFromShip === 1);
        });

        const recommendedVehicles = await recommendMultipleVehiclesForOrder(
          order,
          this.vehicleList,
          this.customers,
          this.products,
          item.recomendedCount,
          [...activeCurrentVehicles, ...activeListVehicles, ...blockedVehicles],
          true,  // isBulk
          false,  // skipTheTonnage
          true,   // setAvailable
          [],     // blockedVehiclesParam
          false,  // isClose
          this.$store.state.userData.token
        );


        return recommendedVehicles;
      } finally {
        this.isRecommendationInProgress = false;
        console.log("vehicleRecomended finished");
      }
    },

    async processOrderItem(blockedVehicles = []) {
      this.List = this.List.filter((item) => item.isCustom == 1);
      if (this.totalCount < this.List.length) {
        this.List = this.List.slice(0, this.totalCount);
      }

      for (let i = 0; i < this.orders?.length; i++) {
        const item = this.orders[i];
        if (!item) {
          continue;
        }

        let recommendedVehicles = await this.vehicleRecomended(
          item,
          blockedVehicles
        );

        if (recommendedVehicles) {
          recommendedVehicles = recommendedVehicles.map((vehicle) => {
            return {
              ...vehicle,
              orderNo: item.orderNo,
              orderName: item.name,
            };
          });

          await this.handleRecommendedVehicles(recommendedVehicles, item);
        }
      }
    },
    async handleRecommendedVehicles(recommendedVehicles, order) {
      if (
        !Array.isArray(recommendedVehicles) ||
        recommendedVehicles.length === 0
      ) {
        this.handleNoRecommendedVehicles();
        return;
      }

      if (recommendedVehicles.length < this.totalCount) {
        this.handleInsufficientVehicles(recommendedVehicles);
      }

      const newDedicatedVehicles = this.getNewDedicatedVehicles(
        recommendedVehicles,
        order
      );

      if (newDedicatedVehicles.length) {
        await this.handleDedicatedVehicles(
          newDedicatedVehicles,
          recommendedVehicles,
          order
        );
      } else {
        this.addRecommendedVehiclesToList(recommendedVehicles, order);
      }
    },
    handleNoRecommendedVehicles() {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Bu sipariş için Uygun araç bulunamadı.",
        false,
        this.$t("general.OkayTitle")
      );
      this.load = false;
    },
    handleInsufficientVehicles(recommendedVehicles) {
      this.insufficientErr = true;
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        `Bu iş için girilen araç sayısı ${this.recomendedCount} ama müsait araç sayısı ${recommendedVehicles.length} olduğu için araç sayısı güncellendi.`,
        false,
        this.$t("general.OkayTitle")
      );
      this.$emit("update-total-count", recommendedVehicles.length);
    },
    getNewDedicatedVehicles(recommendedVehicles, order) {
      return recommendedVehicles.filter(
        (item) =>
          item.fleetCustomers.length &&
          !item.fleetCustomers.some(
            (customer) => customer?.customerId === order?.customerId
          )
      );
    },
    async getCustomerDetail(customerId) {
      try {
        const response = await axios.get(
          `${customer.getAll}?customerId=${customerId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
            },
          }
        );
        if (response.data.data.detail.length > 0)
          return response.data.data.detail[0].shiftHours;
        else {
          this.$swal.fire({
            icon: "warning",
            title: "UYARI!",
            text: "Müşteri kartı veya çalışma saatleri bilgilerine ulaşılamadı. Müşteri silinmiş olabilir, lütfen kontrol edip tekrar deneyin.",
            confirmButtonText: "Tamam",
          });
        }
      } catch (err) {
        this.errorBox(err.response);
      }
    },
    getDayOfWeek(dateStr) {
      const date = dateStr ? new Date(dateStr) : new Date();
      const dayOfWeekNumber = date.getDay();

      return dayOfWeekNumber;
    },
    distanceTwoLocationHour({ fromLat, fromLng, toLat, toLng }) {
      const distance = haversineDistance(
        { lat: fromLat, lng: fromLng },
        {
          lat: toLat,
          lng: toLng,
        }
      );
      return Math.round((distance / 45) * 60 + 20);
    },
    addMinutesToTime(time, minutesToAdd) {
      const timeMoment = moment(time, "HH:mm");
      timeMoment.add(minutesToAdd, "minutes");

      return timeMoment.format("HH:mm");
    },
    isWithinWorkingHours(arrivalTime, workingHours) {
      const { startHour, endHour } = workingHours;

      const arrivalMoment = moment(arrivalTime, "HH:mm");
      const startMoment = moment(startHour, "HH:mm");
      const endMoment = moment(endHour, "HH:mm");

      return arrivalMoment.isBetween(startMoment, endMoment, undefined, "[]");
    },
    async checkDeliveryCustomerWorkingHours(order) {
      const params = {
        fromLat: Number(order.outpointLat),
        fromLng: Number(order.outpointLng),
        toLat: Number(order.targetPointLat),
        toLng: Number(order.targetPointLng),
      };
      const distanceHour = this.distanceTwoLocationHour(params);
      const vehicleArrivalTime = this.addMinutesToTime(
        this.vehicleArrivalTime,
        distanceHour + Number(this.fillingDate)
      );

      const workingHours = await this.getCustomerDetail(
        order.deliveryCustomerId
      );

      if (workingHours[0] === null) return true;
      const dayOfWeek = this.getDayOfWeek();
      const dayOfWeekWorkingHours = workingHours.find(
        (item) => item.dayId === dayOfWeek
      );

      if (!dayOfWeekWorkingHours) return true;
      const result = this.isWithinWorkingHours(
        vehicleArrivalTime,
        dayOfWeekWorkingHours
      );

      return result;
    },

    async checkFillingCustomerWorkingHours(vehicle, order) {
      const params = {
        fromLat: vehicle.latitude,
        fromLng: vehicle.longitude,
        toLat: Number(order.outpointLat),
        toLng: Number(order.outpointLng),
      };
      const distanceHour = this.distanceTwoLocationHour(params);
      const currentTime = moment().format("HH:mm");
      this.vehicleArrivalTime = this.addMinutesToTime(
        currentTime,
        distanceHour
      );
      const workingHours = await this.getCustomerDetail(
        order.fillingCustomerId
      );
      if (workingHours[0] === null) return true;
      const dayOfWeek = this.getDayOfWeek();
      const dayOfWeekWorkingHours = workingHours.find(
        (item) => item.dayId === dayOfWeek
      );
      if (!dayOfWeekWorkingHours) return true;
      const result = this.isWithinWorkingHours(
        this.vehicleArrivalTime,
        dayOfWeekWorkingHours
      );
      return result;
    },
    async handleDedicatedVehicles(
      newDedicatedVehicles,
      recommendedVehicles,
      order
    ) {
      this.dedicatedVehicles = [
        ...this.dedicatedVehicles,
        ...newDedicatedVehicles,
      ];

      const groupedData = newDedicatedVehicles.reduce((acc, item) => {
        item.fleetCustomers.forEach((customer) => {
          if (!acc[customer?.customerName]) {
            acc[customer?.customerName] = [];
          }
          acc[customer?.customerName].push(item.plate);
        });
        return acc;
      }, {});

      const tableData = Object.entries(groupedData).map(
        ([customerName, vehicles]) => ({
          customerName,
          vehicles: vehicles.join(", "),
        })
      );

      const result = await this.$swal.fire({
        icon: "warning",
        title: "UYARI !",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Devam et",
        cancelButtonText: "Yeniden Öner",
        width: "800px",
        html: `
            <div>
              <div>
                <span class="block text-lg font-semibold mb-4">Önerilen araç listesinde başka müşteriye atanmış filoya ait araçlar var:</span>
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full bg-white border border-gray-200">
                  <thead>
                    <tr class="w-full bg-gray-200 text-left text-sm leading-normal text-gray-600 uppercase tracking-wider">
                      <th class="py-3 px-6 border-r border-gray-200">Müşteri</th>
                      <th class="py-3 px-6">Araçlar</th>
                    </tr>
                  </thead>
                  <tbody class="text-gray-700">
                    ${tableData
                      .map(
                        (entry, index) =>
                          `
                            <tr key="${index}" class="border-b border-gray-200 text-xs text-left">
                              <td class="py-3 px-6 border-r border-gray-200">${entry.customerName}</td>
                              <td class="py-3 px-6">${entry.vehicles}</td>
                            </tr>
                          `
                      )
                      .join("")}
                  </tbody>
                </table>
              </div>
              <div>
                <span class="block text-lg font-semibold mt-4">Devam etmek için DEVAM ET'e, yeniden araç önerisi yapmak için YENİDEN ÖNER'e basınız?</span>
              </div>
            </div>
          `,
      });

      if (result.isConfirmed) {
        this.addRecommendedVehiclesToList(recommendedVehicles, order);
      } else {
        await this.processOrderItem(this.dedicatedVehicles);
      }
    },
    async addRecommendedVehiclesToList(recommendedVehicles, order) {
      //   let fillingArrivalFailList = [];
      //   let deliveryArrivalFailList = [];
      //   for (const item of recommendedVehicles) {
      //     if (order.deliveryCustomerId) {
      //       const deliveryWillArrive =
      //         await this.checkDeliveryCustomerWorkingHours(order);
      //       if (!deliveryWillArrive) {
      //         deliveryArrivalFailList.push(item);
      //       }
      //     }

      //     if (order.fillingCustomerId) {
      //       const fillingWillArrive = await this.checkFillingCustomerWorkingHours(
      //         item,
      //         order
      //       );
      //       if (!fillingWillArrive) {
      //         fillingArrivalFailList.push(item);
      //       }
      //     }
      //   }
      //   if (fillingArrivalFailList.length || deliveryArrivalFailList.length) {
      //     const tableData = [
      //       {
      //         title: "Yüklemeye yetişmeyecek araçlar",
      //         vehicles:
      //           fillingArrivalFailList.map((item) => item.vehicle).join(", ") ||
      //           "Yok",
      //       },
      //       {
      //         title: "Boşaltmaya yetişmeyecek araçlar",
      //         vehicles:
      //           deliveryArrivalFailList.map((item) => item.vehicle).join(", ") ||
      //           "Yok",
      //       },
      //     ];

      //     await this.$swal.fire({
      //       icon: "warning",
      //       title: "UYARI !",
      //       showConfirmButton: true,
      //       confirmButtonText: "Tamam",
      //       width: "800px",
      //       html: `
      //     <div>
      //       <div>
      //         <span class="block text-lg font-semibold mb-4">Önerilen araç listesinde müşterinin çalışma saatlerine yetişemeyecek araçlar var:</span>
      //       </div>
      //       <div class="overflow-x-auto">
      //         <table class="min-w-full bg-white border border-gray-200">
      //           <thead>
      //             <tr class="w-full bg-gray-200 text-left text-sm leading-normal text-gray-600 uppercase tracking-wider">
      //               <th class="py-3 px-6 border-r border-gray-200">Durum</th>
      //               <th class="py-3 px-6">Araçlar</th>
      //             </tr>
      //           </thead>
      //           <tbody class="text-gray-700">
      //             ${tableData
      //               .map(
      //                 (entry, index) =>
      //                   `
      //                     <tr key="${index}" class="border-b border-gray-200 text-xs text-left">
      //                       <td class="py-3 px-6 border-r border-gray-200">${entry.title}</td>
      //                       <td class="py-3 px-6">${entry.vehicles}</td>
      //                     </tr>
      //                   `
      //               )
      //               .join("")}
      //           </tbody>
      //         </table>
      //       </div>
      //     </div>
      // `,
      //     });
      //   }
      console.log("concatto", recommendedVehicles);
      
      // Debug: recommended vehicles distance values
      recommendedVehicles.forEach((vehicle, index) => {
        console.log(`DEBUG Vehicle ${index + 1}: ${vehicle.plate}`, {
          distance: vehicle.distance,
          latitude: vehicle.latitude,
          longitude: vehicle.longitude,
          address: vehicle.address,
          distanceWithWashing: vehicle.distanceWithWashing
        });
      });

      this.List = [...this.List, ...recommendedVehicles];
      this.$emit("change", this.List);
    },
    async calculateVehicle() {
      if (this.isCalculationInProgress) {
        console.log("calculateVehicle: Calculation is already in progress");
        return;
      }

      console.log("calculateVehicle called");
      this.isCalculationInProgress = true;

      try {
        if (this.totalCount < 1) {
          this.swalBox(
            "warning",
            this.$t("general.warningTitle"),
            "Araç sayısı en az 1 olmalıdır",
            false,
            this.$t("general.OkayTitle")
          );
          return;
        }
        // asdasdasd
        if (this.vehicleList?.length == 0) {
          this.load = true;
          this.vehicleList = await getLocationAll(
            this.$store.state.userData.token
          );
          this.load = false;
        }

        if (this.isDeleted) {
          console.log("calculateVehicle: isDeleted is true, returning");
          return;
        }

        await this.processOrderItem();
        this.changeState = false;
      } finally {
        this.isCalculationInProgress = false;
      }
    },
    resetChange(isManuel = false) {
      // Kullanılmıyor
      this.changeState = true;
      if (!this.isManuel && !isManuel) {
        this.List = [];
      }
    },
    getCurrentVehicles() {
      // Gemide mevcut olan araçları çek (otomatik ve manuel atamaları hariç tutmak için)
      return axios
        .get(
          bulkShipPlanning.vehiclesAll +
            "?rowId=" +
            this.shipId +
            "&isAll=true",
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then((res) => {
          // Backend isAll=true olduğunda indexed obje döndürüyor, array'e çevir
          let dataArray = res.data.data;
          if (!Array.isArray(dataArray)) {
            // Obje ise, counts'u hariç tutarak array'e çevir
            const { counts, ...indexedData } = dataArray;
            dataArray = Object.values(indexedData);
          }

          const newCurrentVehicles = dataArray.map((item) => {
            return { ...item, plate: item.plaque };
          });

          // Gemide aktif olan araçları filtrele (serbest bırakılmış araçları hariç tut)
          this.currentVehicles = newCurrentVehicles.filter(
            (item) => item.isReleasedFromShip !== 1
          );

          console.log('Gemide mevcut araç sayısı:', this.currentVehicles.length);
        })
        .catch((err) => {
          console.error('Gemideki araçlar yüklenirken hata:', err);
          if (err.response) {
            this.errorBox(err.response);
          }
        })
        .finally(() => {
          this.load = false;
        });
    },
    async save(callback) {
      try {
        const list = this.List.map((item) => {
          return {
            orderNo: item.orderNo,
            orderName: item.orderName,
            vehicle: item.vehicle,
            plate: item.vehicle,
            dorse: item.dorse,
            driverName: item.driverName,
            isCustom: item.isCustom || 0,
            driverTC: item.driverTC,
            capacity: item.capacity,
          };
        });

        if (list.length > 0) {
          await axios.post(
            bulkShipPlanning.vehicleBulkAdd,
            {
              vehicleList: JSON.stringify(list),
              shipId: this.shipId,
              isLaterAddOrder: this.isLaterAddOrder,
            },
            {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            }
          );
          callback(true);
        } else {
          this.swalBox(
            "warning",
            this.$t("general.warningTitle"),
            "Devam etmek için araç eklemeniz gerekmektedir.",
            false,
            this.$t("general.OkayTitle")
          );
          callback(false);
        }
      } catch (err) {
        this.errorBox(err.response);
        callback(false);
      }
    },
  },
  computed: {
    isMultipleDay() {
      if (Array.isArray(this.recomendedList))
        return this.recomendedList.length > 0;
      else return false;
    },
    allSelected() {
      return this.List.length > 0 && this.selectedItems.length === this.List.length;
    },
  },
  async created() {
    this.changeState = this.calculateState != true;
    this.load = true;

    if (this.vehicleList.length == 0) {
      this.vehicleList = await getLocationAll(this.$store.state.userData.token);
    }
    if (this.customers.length == 0)
      this.customers = await getCustomers(this.$store.state.userData.token);
    if (this.products.length == 0)
      this.products = await getProducts(this.$store.state.userData.token);

    // Gemide mevcut olan araçları her zaman yükle (çakışmaları önlemek için)
    // ÖNEMLİ: getCurrentVehicles() bitmeden calculateVehicle() çalışmamalı (race condition)
    if (this.shipId) {
      await this.getCurrentVehicles();
    }

    if (!this.changeState) await this.calculateVehicle();
    this.load = false;
  },
  watch: {
    totalCount: {
      handler(newVal, oldVal) {
        if (this.isManuel || this.isCalculationInProgress) return;
        if (!this.load && newVal > 0 && !this.isDeleted) {
          this.changeState = true;
          // this.debouncedCalculateVehicle();
        } else if (!this.isDeleted) {
          this.List = [];
        }
      },
      immediate: true,
    },
    List(val) {
      this.$emit("change", val);
      // Clear selection when list changes
      this.selectedItems = this.selectedItems.filter((selectedId) => {
        return val.some((item, index) => (item.id || index) === selectedId);
      });
    },
    changeState: {
      handler(newVal, oldVal) {
        if (this.isDeleted || this.isCalculationInProgress) {
          this.changeState = false;
          return;
        }
        if (this.totalCount > 0 && newVal === true && !oldVal) {
          this.List = [];
        }
      },
    },
    center() {
      if (!this.load) {
        this.changeState = true;
      }
    },
    haveType: {
      handler(newVal, oldVal) {
        if (this.isManuel || this.isCalculationInProgress) return;
        if (!this.load && newVal > 0 && !this.isDeleted) {
          this.changeState = true;
          // this.debouncedCalculateVehicle();
        } else if (!this.isDeleted) {
          this.List = [];
        }
      },
      immediate: true,
    },
    order() {
      this.List = [];
    },
  },
};
</script>
